<template>
  <div class="home-content">
    <div class="section banner">
      <img
        class="illustration"
        src="@/assets/images/14ry_bannertp.png"
        height="510"
        alt=""
      />
      <div class="description">
        <h1>标准日本语（日语教材）</h1>
        <p class="paragraph1">
          ●
          已上线《新版中日交流标准日本语》《高考日语突破（修订版）》等书籍配套资源
        </p>
        <div class="download">
          <div class="download-img" @click="openPopup()">
            <img
              src="@/assets/images/14ry_download.png"
              alt=""
              width="220"
              height="74"
            />
          </div>
          <p class="download-desc">
            <span class="white">支持</span>
            <span class="iOS">iOS</span>
            <span>Android</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 官方出品 -->
    <div class="section gfcp">
      <div class="description">
        <h2>官方出品</h2>
        <p class="paragraph2">
          人民教育出版社（人教社）倾情奉献，是与《新版中日交流标准日本语》《高考日语突破》等教材书籍配套的官方正版App。
        </p>
      </div>
      <img
        class="illustration"
        src="@/assets/images/14ry_tp01.jpg"
        width="414"
        height="407"
        alt=""
      />
    </div>
    <!-- 内容全面 -->
    <div class="section nrqm">
      <img
        class="illustration"
        src="@/assets/images/14ry_tp02.jpg"
        width="587"
        height="403"
        alt=""
      />
      <div class="description">
        <h2>内容全面</h2>
        <p class="paragraph2">
          ●
          “标日”系列内容全面，涵盖标日五十音图、课文、生词、语法和练习等丰富内容<br />
          &nbsp;&nbsp;&nbsp;&nbsp;<span class="subline"
            >○ 课文、生词标准语音完美呈现</span
          ><br />
          &nbsp;&nbsp;&nbsp;&nbsp;<span class="subline"
            >○ 动态呈现假名书写，从零起步无负担</span
          ><br />
          &nbsp;&nbsp;&nbsp;&nbsp;<span class="subline"
            >○ 课文、生词、听力配套同步语音，哪里不会点哪里</span
          ><br />
          &nbsp;&nbsp;&nbsp;&nbsp;<span class="subline"
            >○ 语法、练习巩固知识点，能学能练一手掌握</span
          ><br />

          ● “日语高考突破”系列配有听力音频<br />
        </p>
      </div>
    </div>
    <div class="section"></div>
    <!-- 离线使用 -->
    <div class="section lxsy">
      <div class="description">
        <h2>离线使用</h2>
        <p class="paragraph2">
          学习资源包可单独下载，支持离线学习，无流量压力。
        </p>
      </div>
      <img
        class="illustration"
        src="@/assets/images/14ry_tp03.jpg"
        width="557"
        height="412"
        alt=""
      />
    </div>
    <div class="section"></div>
    <!-- 使用方法 -->
    <div class="section syff">
      <img
        class="illustration"
        src="@/assets/images/14ry_tp04.jpg"
        width="322"
        height="408"
        alt=""
      />
      <div class="description">
        <h2>使用方法</h2>
        <p class="paragraph2">
          购买正版图书的用户，通过纸书封底的激活码就能激活电子书的全部内容。
          <br />
          方法如下：
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;1.
          扫描封底二维码下载并安装标准日本语（日语教材）App；<br />
          &nbsp;&nbsp;&nbsp;&nbsp;2. 启动App，注册登录；<br />
          &nbsp;&nbsp;&nbsp;&nbsp;3. 刮开图书封底的激活码涂层，获取激活码；<br />
          &nbsp;&nbsp;&nbsp;&nbsp;4.
          根据提示选择相应书籍按提示输入激活码激活相应内容。<br />
        </p>
      </div>
    </div>

    <div class="section ewm">
      <img
        class="illustration"
        src="@/assets/images/14ry_tp05.gif"
        width="286"
        height="286"
        alt=""
      />
      <div class="description">
        <div class="download">
          <div class="download-img" @click="openPopup()">
            <img
              src="@/assets/images/14ry_download.png"
              alt=""
              width="220"
              height="74"
            />
          </div>
          <p class="more">更多内容陆续上线，敬请期待</p>
        </div>
      </div>
    </div>

    <template v-if="visible">
      <div class="download-popup">
        <div class="icon-close" @click="closePopup()"></div>
        <a
          href="https://itunes.apple.com/us/app/xin-ban-zhong-ri-jiao-liu/id847327884?l=zh&amp;ls=1&amp;mt=8#"
          onmouseover="this.style.cursor='hand'"
        >
          <img src="@/assets/images/iphone.png" alt="" />
        </a>
        <a
          href="https://ebookres.mypep.cn/biaori.apk"
          onmouseover="this.style.cursor='hand'"
          class="a-android"
        >
          <img src="@/assets/images/android.png" alt="" />
        </a>
      </div>
      <div class="mask"></div>
    </template>

    <div class="drawer-ryxly">
      <a href="http://ebook.pep.com.cn/ry/">日语训练营&nbsp;&nbsp;</a>
      <a href="http://ebook.pep.com.cn/ry/"
        ><img src="@/assets/images/logo-ryxly.png" alt="日语训练营"
      /></a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Info",
  components: {},
  props: {},
  data() {
    return {
      visible: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    openPopup() {
      this.visible = true;
    },
    closePopup() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.home-content {
  width: 1002px;
  margin: 0 auto;

  .mask {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(204, 204, 204, 0.5);
  }

  .download-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -220px 0 0 -354px;
    z-index: 1001;
    width: 707px;
    height: 450px;
    background: url("~@/assets/images/14br_win.png") no-repeat;
    background-size: 707px 449px;

    .icon-close {
      width: 40px;
      height: 40px;
      position: absolute;
      right: 0;
      top: 0;
      margin: 10px;
      cursor: pointer;
    }

    & > a {
      width: 221px;
      margin-left: 70px;
      margin-top: 120px;

      &.a-android {
        margin-top: 85px;
      }
    }
  }

  .section {
    border-bottom: 1px solid #ccc;
    display: flex;
    margin-bottom: 20px;
    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }
    &:first-child {
      border-bottom: none;
    }

    .description {
      height: 100%;
      padding: 20px;
      h1 {
        font-size: 24px;
        color: white;
        line-height: 1.5em;
      }
      h2 {
        font-size: 44px;
        color: #000;
        line-height: 1.5em;
        margin: 20px 0;
      }
      .paragraph1 {
        padding: 10px;
        color: white;
        font-size: 18px;
        line-height: 2em;
      }

      .paragraph2 {
        color: #000;
        font-size: 20px;
        line-height: 2em;
      }
      .download {
        padding: 20px;
        margin-top: 20px;
        text-align: center;
        .download-img {
          margin: 0 auto;
          width: 220px;
          cursor: pointer;
        }
        p.download-desc {
          font-size: 16px;
          color: #000;
          margin-top: 20px;
          line-height: 1.5em;
          .white {
            color: white;
            margin-right: 38px;
          }
          .iOS {
            margin-right: 20px;
          }
        }
      }
    }
  }

  .banner {
    height: 536px;
    align-items: flex-end;
    margin-bottom: 0px;

    .description {
      padding-top: 66px;
      flex: none;
      width: 440px;
    }
  }

  .gfcp {
    .description {
      width: 500px;
    }
  }
  .nrqm {
    margin: 0 -150px;
    border-bottom: none;
    .description {
      width: 580px;
      margin-left: 20px;
    }
  }
  .lxsy {
    margin-right: -55px;
    margin-bottom: 0;
    border-bottom: none;
  }

  .syff {
    .illustration {
      object-fit: inherit;
      margin-left: 30px;
    }
    .description {
      margin-left: 60px;
      margin-right: 10px;
    }
  }

  .ewm {
    justify-content: center;
    padding-top: 20px;
    border-bottom: none;
    .description {
      width: 400px;
      margin-left: 80px;
      margin-top: 30px;
      .more {
        font-size: 24px;
        color: #000;
        line-height: 1.5em;
        margin-top: 30px;
      }
    }
  }
}

// 移动端响应式样式
@media (max-width: 768px) {
  .home-content {
    background: #fff !important;
    color: #000 !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 15px;

    .section {
      flex-direction: column !important;
      margin-bottom: 12px !important; // 进一步缩小区块底部间距

      .description {
        width: 100% !important;
        padding: 15px !important;

        // 文字统一为黑色
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p,
        span,
        a {
          color: #000 !important;
        }

        h1 {
          font-size: 28px !important;
          text-align: center;
          color: #000 !important;
        }

        h2 {
          font-size: 32px !important;
          text-align: center;
          margin: 15px 0 !important;
        }

        .paragraph1 {
          font-size: 18px !important;
          text-align: left;
          padding: 8px !important; // 缩小段落内边距，减少与下方按钮的间距
          color: #000 !important;
        }

        .paragraph2 {
          font-size: 18px !important;
          text-align: center;
          line-height: 1.8em !important;
          color: #000 !important;
        }

        .download {
          padding: 8px !important; // 缩小下载区域上下留白
          margin-top: 10px !important;

          .download-img {
            width: 180px !important;
          }

          p.download-desc {
            font-size: 18px !important;
            margin-top: 10px !important; // 缩小按钮与文字说明的间距
            color: #000 !important;

            .white,
            .iOS {
              margin-right: 15px !important;
              color: #000 !important;
            }
          }
        }
      }

      .illustration {
        width: 100% !important;
        height: auto !important;
        margin: 0 auto !important;
        display: block !important;
      }
    }

    .banner {
      height: auto !important;
      min-height: 400px;

      .description {
        width: 100% !important;
        padding-top: 30px !important;
      }
    }

    // “离线使用”区域：段落小一号
    .lxsy {
      .description {
        .paragraph2 {
          font-size: 16px !important;
        }
      }
    }

    // “内容全面”区域：标题居中，正文左对齐
    .nrqm {
      .description {
        h2 {
          text-align: center !important;
        }
        .paragraph2 {
          text-align: left !important;
          padding-left: 4px;
          padding-right: 4px;
          .subline {
            font-size: 14px !important;
          }
        }
      }
    }

    // “官方出品”区域：段落左对齐
    .gfcp {
      .description {
        padding-top: 4px !important; // 进一步缩小与上一区块的间距
        .paragraph2 {
          text-align: left !important;
          padding-left: 4px;
          padding-right: 4px;
        }
        h2 {
          margin: 6px 0 !important; // 进一步减少标题上下间距
        }
      }
    }

    // “使用方法”区域：段落左对齐
    .syff {
      .description {
        .paragraph2 {
          text-align: left !important;
          padding-left: 4px;
          padding-right: 4px;
        }
      }
    }

    .gfcp,
    .nrqm,
    .lxsy,
    .syff,
    .ewm {
      margin: 0 !important;

      .description {
        width: 100% !important;
        margin: 0 !important;
      }
    }

    .download-popup {
      width: 90% !important;
      height: 250px !important;
      margin: -150px 0 0 -45% !important;
      background-size: 100% auto !important;
      background-color: white !important;
      border-radius: 10px !important;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;

      .icon-close {
        width: 30px !important;
        height: 30px !important;
        margin: 5px !important;
      }

      & > a {
        position: absolute !important;
        width: 140px !important;

        img {
          width: 100% !important;
          height: auto !important;
        }

        // iPhone 按钮放在左上方
        &:first-of-type {
          left: 20px !important;
          top: 60px !important;
          margin: 0 !important;
        }

        // Android 按钮放在iPhone按钮下方
        &.a-android {
          left: 20px !important;
          top: 140px !important;
          margin: 0 !important;
        }
      }
    }
  }
}
</style>
